import { type, value } from '@capital-access/common/user';

export class SurveillanceSettings {
  @value(type.boolean) enabled: boolean = true;
}
